module.exports = __webpack_public_path__ + "img/scb.5b363e2b.png";